import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { CustomizerSettingsService } from '../../../../customizer-settings/customizer-settings.service';
import { AsmService } from '../../../../services/asm/asm.service';
import { TranslocoModule } from '@ngneat/transloco';
import { Port, ScanHistory } from '../../../../interfaces/asm/models';
import { QueryPortsResponse } from '../../../../interfaces/asm/QueryPortsResponse';

@Component({
    selector: 'app-ports',
    standalone: true,
    imports: [MatCardModule, TranslocoModule],
    templateUrl: './ports.component.html',
    styleUrl: './ports.component.scss',
})
export class PortsComponent {
    // isToggled
    isToggled = false;

    @Input() scan: ScanHistory;
    data: Port[] = [];

    constructor(
        public themeService: CustomizerSettingsService,
        private asmService: AsmService
    ) {
        this.themeService.isToggled$.subscribe((isToggled) => {
            this.isToggled = isToggled;
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    // Dark Mode
    toggleTheme() {
        this.themeService.toggleTheme();
    }

    // changeData
    changeData() {
        this.asmService
            .getQueryPorts(this.scan.id)
            .subscribe((response: QueryPortsResponse) => {
                this.data = response.ports;
            });
    }
}
